"use strict";
// MIT License
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2CircleContact = void 0;
const b2_collide_circle_1 = require("../collision/b2_collide_circle");
const b2_contact_1 = require("./b2_contact");
/** @internal */
class b2CircleContact extends b2_contact_1.b2Contact {
    Evaluate(manifold, xfA, xfB) {
        (0, b2_collide_circle_1.b2CollideCircles)(manifold, this.GetShapeA(), xfA, this.GetShapeB(), xfB);
    }
}
exports.b2CircleContact = b2CircleContact;
